import React from "react";

// components
import Swiggy from "../components/PlatformApp/Swiggy";
import { Loading } from "../components/_commons/Loading";

// third party
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";

const PlatformApp = ({ match, biz, bizPlatforms, access }) => {
	const platform = match?.params?.platform || "";

	const renderPlatform = () => {
		if (bizPlatforms?.items?.length === 0 || bizPlatforms?.isLoading) {
			return (
				<div className="platform-app">
					<Loading />
				</div>
			);
		}
		if (
			platform === "swiggy" &&
			bizPlatforms?.items?.some(
				(plf) =>
					plf?.platformName?.toLowerCase() === "swiggy" || plf?.platform?.name?.toLowerCase() === "swiggy"
			) &&
			biz?.country === "India" &&
			(access?.isAdmin || access.isCatalogueManagement || access.isHubManagement || access.isSalesAnalysis)
		) {
			return <Swiggy />;
		}
		return <Redirect to="/error" />;
	};

	return <div className={"platform-app-container section-container-common " + platform}>{renderPlatform()}</div>;
};
const mapStateToProps = (store) => ({
	bizPlatforms: store.configItems.bizPlatforms,
	biz: store.login.loggedInbizDetail,
	access: store.login.loginDetail.access
});
export default connect(mapStateToProps)(PlatformApp);
